import localSeedBackupsApiDefinition from './api/api.js'
import {
  localSeedBackupsAtomDefinition,
  localSeedBackupMaxAgeAtomDefinition,
  localSeedPrivateBackupsAtomDefinition,
} from './atoms/index.js'
import { defaultReasons, forever } from './constants.js'
import localSeedBackupsDefinition from './module/index.js'
import { localSeedBackupsPluginDefinition } from './plugins/index.js'

const localSeedBackups = (
  { defaultMaxAge = forever, reasons = defaultReasons, shouldBackup } = Object.create(null)
) => {
  return {
    id: 'localSeedBackups',
    definitions: [
      { definition: localSeedBackupsDefinition },
      { definition: localSeedBackupsAtomDefinition },
      { definition: localSeedPrivateBackupsAtomDefinition },
      { definition: localSeedBackupsApiDefinition },
      {
        definition: localSeedBackupsPluginDefinition,
        config: {
          reasons,
          shouldBackup,
        },
      },
      {
        definition: localSeedBackupMaxAgeAtomDefinition,
        storage: { namespace: 'localSeedBackups' },
        config: { defaultMaxAge },
      },
    ],
  }
}

export default localSeedBackups
